export class TravelRequestSuccessScreen {
  constructor() { }

  close() {
    window.close();
  }
}
